import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleInsuranceDto } from './create-vehicle-insurance.dto';

/**
 * Update vehicle insurance DTO
 */
export class UpdateVehicleInsuranceDto extends CreateVehicleInsuranceDto {
	@TransformInt()
	id!: number;
}
